module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/DrainTheOceans_NetEffects.6fc1ec9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/DrainTheOceans_NetEffects.jpg
// module id = SmF5
// module chunks = 0